export default __webpack_public_path__ + "static/media/Messages.c38ca4fb.svg";